 $(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }
    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
         headers: {
            "X-TimeZoneName": timeZoneName,
            "X-Language": language,
            "X-Prefix": prefix
        },
    });

const Uris = {
  jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
  nextPageUri: (() => {
    switch (language) {
     case "fi":
        return "/fi/kiitos-yhteys/";               // Finnish
      case "en":
        return "/en/thank-you-contact-form/";         // English
      case "de":
        return "/de/danke-kontaktformular/";          // German
      case "sv":
        return "/sv/tack-kontaktformularet/";         // Swedish
      case "ru":
        return "/ru/spasibo-forma-obratnoy-svyazi/";  // Russian
      case "is-en":
         return "/is-en/thank-you-contact-form/"; 
           case "is":
         return "/is/takk-fyrir-hafdu-samband/";
          case "ee-en":
         return "/ee-en/thank-you-contact-form/"; 
           case "ee":
         return "/ee/aitah/";
      default:
        return "/en/thank-you-contact-form/";         // fallback
    }
  })(),
  uri: (() => {
    switch (language) {
      case "fi":
        return "/fi/yhteys";    // Finnish
      case "en":
        return "/en/contact/";         // English
      case "de":
        return "/de/kontaktieren-sie-uns/";          // German
      case "sv":
        return "/sv/kontakt/";         // Swedish
      case "ru":
        return "/ru/kontakty/";  // Russian
      case "is-en":
        return "/is-en/contact/"; 
         case "is":
        return "/is/hafdu-samband/";    
        
      default:
        return "/en/contact/";         // fallback
    }
  })()
};

    $("#contactFormForm").on("submit", function(event) {
        event.preventDefault();
        if ($('#contactFormForm')[0].checkValidity()) {
            $("#contactFormSendBtn").prop("disabled", true);
            $("#contactFormSendBtn").css("background-color", "#6c757d");
            let email = $("#contactFormEmail").val();
            let firstName = $("#contactFormFirstName").val();
            let lastName = $("#contactFormLastName").val();
            let message = $("#contactFormMessage").val();
            let phoneNumber = $("#contactFormPhoneNumber").val();
            let code = $("#contactFormReason").val();
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phoneNumber,
                competitionName: "contactPageForm",
                uri: Uris.uri,
                languageCode: language,
                code: code,
            };

            // Disable the button to prevent multiple submissions
            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#contactFormSendBtn").prop("disabled", false);
                    $("#contactFormSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#contactFormForm')[0].checkValidity();

        if (formValid) {
            // Enable button and change color
            $("#contactFormSendBtn").prop("disabled", false);
            $("#contactFormSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#contactFormSendBtn").prop("disabled", true);
            $("#contactFormSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }
    // Trigger the button state change on input and checkbox changes
    $('#contactFormForm input').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});

